export default __webpack_public_path__ + "static/media/paymentIcon.7af21822.svg";